import { find } from 'lodash/fp';

import constants from '../../ahm-constants';

const { SERVICE } = constants;

// Choosable extras with Orthodontics have lifetime limits that don't apply to other services in the group
// For this reason they're on the service object itself, so we retrieve limits from there if they're present
// @ts-expect-error - Automatic, Please fix when editing this file
const getOrthodonticsLifetimeLimit = (services) => {
  const orthodonticsService = find({ id: SERVICE.ORTHODONTICS }, services);
  return orthodonticsService?.limits?.lifetime;
};

export default getOrthodonticsLifetimeLimit;
